import { MessageDisplayUtil } from 'src/message-display-utils';
// import { InitiatePaymentPage } from './../../modal-screens/initiate-payment/initiate-payment.page';
import { PaymentGatewayInfo, PlayerClubAccount } from './../../../../data/mygolf.data';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  AlertController,
  LoadingController,
  ModalController,
  Platform,
  ToastController
} from '@ionic/angular';
import {
  map,
  take
} from 'rxjs/operators';
import {
  ClubHandicap,
  ClubInfo,
  ClubMembership,
  HandicapCalculation,
  PlayerInfo
} from 'src/data/mygolf.data';
import {
  HandicapService
} from 'src/providers/handicap-service/handicap-service';
import {
  PlayerService
} from 'src/providers/player-service/player-service';
import {
  TrasactionModalComponent
} from '../../modal-screens/player-refund-redeem-history/trasaction-modal/trasaction-modal.component';
import {
  Keyboard
} from '@ionic-native/keyboard/ngx';
import {
  PerformanceClubListPage1
} from '../../performance/club-list1/club-list1.page';
import { PlayerPayClubMembershipPage } from '../../player-club-membership/player-pay-club-membership/player-pay-club-membership.page';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { UpdateNhsModalComponent } from '../../normalgame/flight-setup/update-nhs-modal/update-nhs-modal.component';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';

// import * as global from '@globals'

@Component({
  selector: 'app-manage-membership-page',
  templateUrl: './manage-membership-page.component.html',
  styleUrls: ['./manage-membership-page.component.scss'],
})
export class ManageMembershipPageComponent implements OnInit {

  @Input() player$: any;
  public memberships: Array < ClubMembership > = [];
  public playerClubHcp: any;
  playerHcpSystem: string;
  playerId: number;
  playerBalance: number = 0;
  playerAccountDetails: any;

  constructor(
    private mdlCtrl: ModalController,
    private handicapService: HandicapService,
    private playerService: PlayerService,
    private alertCtl: AlertController,
    private platform: Platform,
    private keyboard: Keyboard,
    private loadingCtrl: LoadingController,
    private paymentService: PaymentService,
    private flightService: ClubFlightService,
    private toastCtl: ToastController
  ) {}

  ngOnInit() {

    this.refreshMembership()

    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      this.playerId = player.id | player.playerId;
    });

  }

  async refreshMembership() {
    this.playerService.getPlayerMemberships().subscribe({
      next: ((memberships: Array < any > ) => {
        if (memberships) {
          this.memberships = memberships;
        }
        this.refreshMygolfHandicap()
      }),
      error: ((error) => {}),
      complete: (() => {})
    })
  }

  async refreshMygolfHandicap() {
    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
      this.playerHcpSystem = player.defaultHandicapSystem
    });

    this.handicapService.getHandicapHistory(_player.playerId).pipe(map(res => {
      return res
    })).subscribe((data: Array < HandicapCalculation > ) => {
      if (data.length > 0) {

        this.handicapService.getClubHandicap(data[0].player.playerId).pipe(map(res => {
          return res;
        })).subscribe((data: Array < ClubHandicap > ) => {
          let clubHandicap = data;
          this.playerClubHcp = this.memberships
          this.playerClubHcp.hcpDetail = [];

          console.log(' this.playerClubHcp: ', this.playerClubHcp);
          if (data && data.length > 0) {
            this.memberships.forEach((m: ClubMembership) => {
              clubHandicap.forEach((ch: ClubHandicap) => {

                if (m.club.clubId === ch.clubInfo.clubId && ch.handicapSystem && ch.handicapSystem.id === this.playerHcpSystem) {
                  m.hcpDetail = ch
                } else if (m.club.clubId === ch.clubInfo.clubId && ch.handicapSystem && ch.handicapSystem.id.toLowerCase().includes('nhs')) {
                  m.nhsHcpDetail = ch;
                }
              })
              this.playerClubHcp.hcpDetail.push(m.hcpDetail);

            })

            this.memberships.sort((a: ClubMembership, b: ClubMembership) => {
              if (a.homeClub && !b.homeClub) return -1;
              else if (!a.homeClub && b.homeClub) return 1;
              else return 0;
            })
          }
        })
      }
    }, (error) => {
      console.log('error: ', error);
    }, () => {

    })
  }

  async setHomeClub(membership: ClubMembership) {
    // let confirm = await this.alertCtl.create({
    //   header: 'Set Home Club',
    //   message: 'Do you want to set ' +
    //     membership.club.clubName + ' as your home club?',
    //   buttons: [{
    //       text: 'No',
    //       handler: () => {
    //         confirm.dismiss();
    //         return false;
    //       }
    //     },
    //     {
    //       text: 'Set Home',
    //       handler: () => {
    //         confirm.dismiss()
    //           .then(() => {
    //             this._setHomeclub(membership);
    //           });
    //         return false;
    //       }
    //     }
    //   ]
    // });
    // confirm.present();
    let modal = await this.mdlCtrl.create({
      component: DeleteRoomModalComponent,
      showBackdrop:true,
      mode:'ios',
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        mode:'homeClub',
        header:'Set Home Club',
        msg:'Do you want to set' + membership.club.clubName + ' as your home club?'
      }
    });
    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data){
        if(data?.data === 'confirm'){
          this._setHomeclub(membership);
        }
      }
    })
  }
  private _setHomeclub(membership: ClubMembership) {
    this.playerService.updateClubMembership(membership.club.clubId,
        membership.membershipNumber, true)
      .subscribe(() => {
        this.refreshMembership();
      })
  }

  async deleteMembership(membership: ClubMembership) {
    // let confirm = await this.alertCtl.create({
    //   header: 'Delete Membership',
    //   message: 'Do you want to delete your membership details for ' +
    //     membership.club.clubName + '?',
    //   buttons: [{
    //       text: 'No',
    //       role: 'cancel',
    //       handler: () => {
    //         confirm.dismiss();
    //         return false;
    //       }
    //     },
    //     {
    //       text: 'Delete',
    //       cssClass: 'delete-item',
    //       role: 'delete',
    //       handler: () => {
    //         confirm.dismiss()
    //           .then(() => {
    //             this._deleteClubMembership(membership);
    //           });
    //         return false;
    //       }
    //     }
    //   ]
    // });
    // confirm.present();

    let modal = await this.mdlCtrl.create({
      component: DeleteRoomModalComponent,
      showBackdrop:true,
      mode:'ios',
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        mode:'deleteMembership',
        header:'Delete Membership',
        msg:'Do you want to delete your membership details for ' + membership.club.clubName + '?'
      }
    });
    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data){
        if(data?.data === 'confirm'){
          this._deleteClubMembership(membership);
        }
      }
    })
  }
  private _deleteClubMembership(membership: ClubMembership) {
    this.playerService.deleteClubMembership(membership.club.clubId)
      .subscribe(() => {
        this.refreshMembership();
      });
  }

  async openMembershipOptions(club: ClubInfo, membership ? : string) {
    const updateMembership = await this.mdlCtrl.create({
      component:UpdateNhsModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        mode:'updateMember',
        header:'Club Membership',
        message:'Enter your Membership Number and click Save',
        value:membership
      }
    })

    await updateMembership.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    updateMembership.onDidDismiss().then((data) => {
      if (data.data) {
        console.log('data.data: ', data.data);
          if (this.platform.is('ios') && this.platform.is('capacitor'))
          this.keyboard.hide();
          this._addMembership(club, data?.data);

      }
    })
    // let prompt = await this.alertCtl.create({
    //   header: 'Club Membership',
    //   message: 'Enter your Membership Number and click Save',
    //   inputs: [{
    //     name: 'title',
    //     placeholder: 'Membership Number',
    //     value: membership
    //   }, ],
    //   buttons: [{
    //       text: 'Cancel',
    //       handler: data => {
    //         prompt.dismiss();
    //         if (this.platform.is('ios') && this.platform.is('capacitor')) {
    //           this.keyboard.hide();
    //         }
    //         return false;
    //       }
    //     },
    //     {
    //       text: 'Save',
    //       handler: data => {
    //         prompt.dismiss()
    //           .then(() => {
    //             if (this.platform.is('ios') && this.platform.is('capacitor')) {
    //               this.keyboard.hide();
    //             }
    //             if (data && data.title) {
    //               this._addMembership(club, data.title);
    //             }
    //           });
    //         return false;
    //       }
    //     }
    //   ]
    // });
    // prompt.present();

  }
  private _addMembership(club: any, membership: string) {
    console.log('membership: ', membership);
    let data = club.clubInfo ? club.clubInfo.clubId : club.clubId
    console.log('data: ', data);
    this.playerService.updateClubMembership(data, membership)
      .subscribe(() => {
        this.refreshMembership();
      })
  }

  back() {
    this.mdlCtrl.dismiss();
  }

  currentStatus: string = 'Active';
  toggleStatus(data: string) {
    if (!data) return

    this.currentStatus = data;
  }

  async moreActionMenu(membership: ClubMembership, club: ClubInfo, value ? : any) {
    const modal = await this.mdlCtrl.create({
      component: TrasactionModalComponent,
      mode: 'ios',
      showBackdrop:true,
      swipeToClose:true,
      cssClass: this.platform.is('mobile') ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        isFrom: 'membershipMenu'
      }
    })
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data?.data) {
        switch (data?.data) {
          case 'setHome':
            this.setHomeClub(membership)
            break;
          case 'updateMshipNo':
            this.openMembershipOptions(club, value)
          break;
          case 'viewStat':
            // this.openMembershipOptions(club, value)
            break;
          case 'makePayment':
            this.onClickMakePayment(membership)
            break;
          case 'delete':
            this.deleteMembership(membership)
            break;

        }

      }
    })
  }

  async openAddClubMembership() {
    let modal = await this.mdlCtrl.create({
      component: PerformanceClubListPage1,
      cssClass: 'ion-infinite-scroll',
      showBackdrop:true,
      mode: 'ios',
      componentProps: {
        openedModal: true,
        forMembership: true
      }
    })

    modal.onDidDismiss().then((data: any) => {
      if (data && (data.data.clubInfo || data.data.courseInfo)) {
        this.openMembershipOptions(data.data);
      }
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    });
    modal.present();
  }

  onClickMakePayment(membership) {
    console.debug("making payment ", membership)
    this.getPlayerAccountDetails(membership)
    .then((result: any)=>{
      if(result) {
        this.onMakePayment(membership);
      }
    }).catch((error: any)=>{
      MessageDisplayUtil.showErrorToast('There was an error. Please try again in a few moments', this.platform, this.toastCtl,
      5000, "bottom");
    })
  }

  async getPlayerAccountDetails(membership) {
    return new Promise(async (resolve, reject) => {

      let _clubId = membership.club.clubId; //this.clubInfo.clubId;
      let _playerId = this.playerId;
      let loader = this.loadingCtrl.create({
        showBackdrop: false
      });
      (await loader).present().then(() => {
          let _params = {
            clubId: _clubId,
            playerId: _playerId,
          }
        this.flightService.getPlayerClubAccount(_params)
        .subscribe(async (data: PlayerClubAccount) => {
          if (data) {
            if(data.effectiveBalance !== undefined && data.effectiveBalance < 0) {
              this.playerBalance = data.effectiveBalance * -1;
            } else this.playerBalance = 0;
            this.playerAccountDetails = data;
            console.debug("Player Club Account Stats : ", data)
            resolve(true)
          }

          if (loader) (await loader).dismiss();
        }, async (error) => {
          if (loader) (await loader).dismiss();
          reject(true)
        });
      })
    });
  }


  async onMakePayment(membership) {
    console.debug("Player Club Account Stats : ", this.playerBalance, this.playerAccountDetails)
    let paymentModal = await this.mdlCtrl.create({
      component: PlayerPayClubMembershipPage,
      cssClass: 'ion-infinite-scroll',
      componentProps: {
        accountDetails: this.playerAccountDetails,
        clubInfo: membership.club,
        clubMembership: membership,
      }
    });
    paymentModal.onDidDismiss().then((data: any) => {

    });
    paymentModal.present();
  }


  paymentGatewayList: Array<any> = [];


}
